import { Text, View } from "react-native";
import { SubmittedFormModel } from "app/services/api/types/forms/models/SubmittedFormModel";
import ViewDocuments from "app/components/molecules/ViewDocuments";
import { QuestionTypeEnum } from "app/services/api/types/forms/enums/QuestionTypeEnum";
import { AssessmentNotes } from "./AssessmentNotes";

interface Props {
  submittedForm: SubmittedFormModel;
}
export function AssessmentPreview({ submittedForm }: Props) {
  return (
    <View className="gap-4">
      {submittedForm.sections.map((section) => (
        <View key={section.id} className="gap-4">
          <Text className="text-md font-semibold">{section.name}</Text>
          {section.questions.map((question) => {
            const value = question.answer?.value?.join(", ");
            const media = question.answer?.media;
            const hasValue =
              !!value &&
              question.type !== QuestionTypeEnum.ELECTRONIC_SIGNATURE;
            const hasFreeText = !!question.answer?.free_text;
            const hasMedia = !!media?.length;
            const hasAny = hasValue || hasMedia || hasFreeText;
            return (
              <View key={`${question.id}`} className="grid grid-cols-3">
                <Text className="text-gray-500">{question.content}</Text>
                <View className="gap-2 col-span-2">
                  {hasValue ? (
                    <Text className={`${hasValue ? "" : "text-gray-400"}`}>
                      {`${value}${question.unit && !submittedForm.total_score ? question.unit : ""}`}
                    </Text>
                  ) : null}
                  {hasMedia ? (
                    <ViewDocuments
                      documents={question.answer!.media ?? []}
                      size="xs"
                    />
                  ) : null}
                  {hasFreeText ? (
                    <Text>{question.answer!.free_text}</Text>
                  ) : null}
                  {!hasAny ? <Text>N/A</Text> : null}
                </View>
              </View>
            );
          })}
        </View>
      ))}
      <AssessmentNotes submittedForm={submittedForm} />
    </View>
  );
}
